import { type ComputedArrivalDto, ETA_PROVIDER } from "@clipboard-health/contract-backend-main";
import { API_TYPES, type ShiftAuctionBidBody } from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { type ComputedArrivalData } from "@src/appV2/redesign/ArrivalTime/computeArrivalData";

function toProviderEnum(provider: ComputedArrivalData["provider"]): ComputedArrivalDto["provider"] {
  if (provider === "AWS_LOCATION") {
    return ETA_PROVIDER.AWS_LOCATION;
  }

  if (provider === "SHIFT_START") {
    return ETA_PROVIDER.SHIFT_START;
  }

  return ETA_PROVIDER.GOOGLE_MAPS;
}

function toComputedArrivalDto(
  computedArrivalData: ComputedArrivalData | undefined
): ComputedArrivalDto | undefined {
  if (!isDefined(computedArrivalData)) {
    return undefined;
  }

  return {
    provider: toProviderEnum(computedArrivalData.provider),
    targetArrivalTime: computedArrivalData.targetArrivalTime.toISOString(),
    gracePeriodInMins: computedArrivalData.gracePeriodInMinutes,
    durationInMinutes: computedArrivalData.durationInMinutes,
    distanceInMeters: computedArrivalData.distanceInMeters,
  };
}

interface ToShiftAuctionBidBodyParams {
  shiftAuctionId: string;
  bidAmount: number;
  computedArrivalData: ComputedArrivalData | undefined;
}

export function toShiftAuctionBidBody({
  shiftAuctionId,
  bidAmount,
  computedArrivalData,
}: ToShiftAuctionBidBodyParams): ShiftAuctionBidBody {
  return {
    data: {
      type: API_TYPES.shiftAuctionBid,
      attributes: {
        bidAmount: {
          amountInMinorUnits: Math.round(bidAmount * 100),
          currencyCode: "USD" as const,
        },
        computedArrival: toComputedArrivalDto(computedArrivalData),
      },
      relationships: {
        shiftAuction: {
          data: {
            type: API_TYPES.shiftAuction,
            id: shiftAuctionId,
          },
        },
      },
    },
  };
}
